import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { BackGuard } from '@guards/back.guard';
import { NoAccessGuard } from '@guards/no-access.guard';
import { ParamRegexGuard } from '@guards/param-regex.guard';
import { StaffUserGuard } from '@guards/staff-user.guard';
import { InstitutionResolveService } from '@services/institution-resolve.service';
import { StudentsResolveService } from '@services/students-resolve.service';
const ɵ0 = () => import("./modules/lgpd/lgpd.page.module.ngfactory").then(m => m.LgpdPageModuleNgFactory), ɵ1 = () => import("./modules/migrate-to-aplicatudo-guide/migrate-to-aplicatudo-guide.module.ngfactory")
    .then(m => m.MigrateToAlicatudoGuideModuleNgFactory), ɵ2 = () => import("./modules/bhave-parents/bhave-parents.module.ngfactory").then(m => m.BhaveParentsPageModuleNgFactory), ɵ3 = () => import("./modules/internal-admin/internal-admin.module.ngfactory").then(m => m.InternalAdminPageModuleNgFactory), ɵ4 = () => import("./modules/staff/staff.module.ngfactory").then(m => m.StaffPageModuleNgFactory), ɵ5 = () => import("./modules/evento/evento.module.ngfactory").then(m => m.EventoPageModuleNgFactory), ɵ6 = () => import("./modules/not-found/not-found.module.ngfactory").then(m => m.NotFoundPageModuleNgFactory), ɵ7 = () => import("./modules/registration-invite/registration-invite.module.ngfactory").then(m => m.RegistrationInviteModuleNgFactory), ɵ8 = () => import("./modules/forgot-password/forgot-password.module.ngfactory").then(m => m.ForgotPasswordPageModuleNgFactory), ɵ9 = () => import("./modules/redefine-password/redefine-password.module.ngfactory").then(m => m.RedefinePasswordModuleNgFactory), ɵ10 = () => import("./modules/login/login.page.module.ngfactory").then(m => m.LoginPageModuleNgFactory), ɵ11 = () => import("./modules/no-access/no-access.module.ngfactory").then(m => m.NoAccessPageModuleNgFactory), ɵ12 = () => import("./modules/institution-select/institution-select.module.ngfactory").then(m => m.InstitutionSelectPageModuleNgFactory), ɵ13 = { regexList: ['^([0-9]+)$'], params: ['institutionId'], redirectTo: 'pagina-nao-encontrada' }, ɵ14 = () => import("./modules/main-layout/main-layout.module.ngfactory").then(m => m.MainLayoutModuleNgFactory), ɵ15 = () => import("./modules/delete-account/delete-account.module.ngfactory").then(m => m.DeleteAccountPageModuleNgFactory);
const routes = [
    { path: 'como-excluir-sua-conta', loadChildren: ɵ0 },
    {
        path: 'como-migrar-para-o-bhave-2',
        loadChildren: ɵ1,
    },
    {
        path: 'bhave-parents',
        loadChildren: ɵ2,
    },
    {
        path: 'admin',
        loadChildren: ɵ3,
        canActivate: [AuthGuard, StaffUserGuard],
    },
    {
        path: 'suporte',
        loadChildren: ɵ4,
        canActivate: [AuthGuard, StaffUserGuard],
    },
    { path: 'evento', loadChildren: ɵ5 },
    { path: 'pagina-nao-encontrada', loadChildren: ɵ6 },
    {
        path: 'convite',
        loadChildren: ɵ7,
    },
    {
        path: 'esqueci-minha-senha',
        loadChildren: ɵ8,
    },
    {
        path: 'redefinir-senha',
        loadChildren: ɵ9,
    },
    { path: 'login', loadChildren: ɵ10 },
    {
        path: 'sem-acesso',
        loadChildren: ɵ11,
        canActivate: [AuthGuard],
    },
    {
        path: 'instituicoes',
        loadChildren: ɵ12,
        canActivate: [AuthGuard, NoAccessGuard],
    },
    {
        path: ':institutionId',
        canActivate: [AuthGuard, ParamRegexGuard, NoAccessGuard],
        canDeactivate: [BackGuard],
        data: ɵ13,
        resolve: { institution: InstitutionResolveService, students: StudentsResolveService },
        loadChildren: ɵ14,
    },
    {
        path: 'remover-conta',
        loadChildren: ɵ15,
    },
    { path: '**', redirectTo: 'login' },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15 };
